// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgNavigationEscape = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.237 4a.49.49 0 0 1 .48.5v1a.49.49 0 0 1-.48.5H7.235l5.207 5.425a.515.515 0 0 1 0 .707l-.678.707a.467.467 0 0 1-.68 0L5.878 7.414V9.5a.49.49 0 0 1-.48.5h-.96a.49.49 0 0 1-.48-.5v-5c0-.276.215-.5.48-.5zm6.653 1.348a7.939 7.939 0 0 1 2.828 3.59 8.311 8.311 0 0 1 .437 4.623 8.109 8.109 0 0 1-2.102 4.096 7.59 7.59 0 0 1-3.932 2.19 7.395 7.395 0 0 1-4.437-.456 7.757 7.757 0 0 1-3.447-2.946 8.224 8.224 0 0 1-1.28-3.945c-.016-.276.2-.5.466-.5h.958c.265 0 .478.224.5.5a6.166 6.166 0 0 0 .951 2.834 5.819 5.819 0 0 0 2.586 2.21 5.547 5.547 0 0 0 3.329.342 5.695 5.695 0 0 0 2.95-1.642 6.082 6.082 0 0 0 1.577-3.073 6.234 6.234 0 0 0-.328-3.468 5.955 5.955 0 0 0-2.122-2.693 5.613 5.613 0 0 0-2.722-.991.525.525 0 0 1-.48-.52V4.5c0-.276.216-.502.48-.484a7.477 7.477 0 0 1 3.788 1.332z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgNavigationEscape;
